module.exports = {
  "country": "RS",
  "artist": "Konstrakta",
  "song": "In Corpore Sano",
  "year": "2022",
  "place": "5",
  "spotify": "1JaOUMmaSZlWfONvT4HTlg"
};